import { getBans, getPlayablePicks } from "model/Match/TrackPick";
import { CenterFlexColumn } from "styles/layout";
import { H2HTrackBasedTrackStats } from "./H2HTrackBasedTrackStats";
import { H2HTrackBasedBans } from "./H2HTrackBasedBans";
import { TrackBasedMatchSet } from "model/Match/Set/MatchSet";

interface Props {
  set: TrackBasedMatchSet;
  rosterOneId: string;
  rosterTwoId: string;
  matchId: string;
  tournamentId: string;
}

export const H2HTrackBasedTracks = ({
  set,
  rosterOneId,
  rosterTwoId,
  matchId,
  tournamentId,
}: Props) => {
  const playablePicks = getPlayablePicks(set);
  const bans = getBans(set.picks);
  const teamOneBanTrackIds = bans
    .filter((b) => b.rosterId === rosterOneId)
    .map((b) => b.trackId);
  const teamTwoBanTrackIds = bans
    .filter((b) => b.rosterId === rosterTwoId)
    .map((b) => b.trackId);
  return (
    <CenterFlexColumn style={{ rowGap: "10px" }}>
      {playablePicks.map((pick, pickIdx) => (
        <H2HTrackBasedTrackStats
          key={`${pickIdx}-${pick.trackId}`}
          trackId={pick.trackId}
          pickingRosterId={pick.rosterId}
          rosterOneId={rosterOneId}
          rosterTwoId={rosterTwoId}
          matchTrack={set.tracks.find((t) => t.trackId === pick.trackId)}
          matchId={matchId}
          tournamentId={tournamentId}
        />
      ))}

      {(!!teamOneBanTrackIds.length || !!teamTwoBanTrackIds.length) && (
        <H2HTrackBasedBans
          teamOneBanTrackIds={teamOneBanTrackIds}
          teamTwoBanTrackIds={teamTwoBanTrackIds}
          tournamentId={tournamentId}
        />
      )}
    </CenterFlexColumn>
  );
};
